export const mapLogLevel = logLevel => logLevel.toLowerCase();